import { isSameDay } from 'date-fns';
import { parseDateTimeLocal } from '@/utils/dateInput';
import type { SelectOption } from '@/components/ui/Select';

export const HOUR_VALUES = Array.from({ length: 24 }, (_, h) => String(h).padStart(2, '0'));

export const MINUTE_VALUES = Array.from({ length: 60 }, (_, m) => String(m).padStart(2, '0'));

export const QUICK_MINUTE_VALUES = ['00', '05', '10', '15', '20', '25', '30', '35', '40', '45', '50', '55'];

export function buildHourOptions(draftDate: Date | null, min?: string, max?: string): SelectOption[] {
  const minDt = parseDateTimeLocal(min);
  const maxDt = parseDateTimeLocal(max);
  return HOUR_VALUES.map((value) => {
    const h = Number(value);
    let disabled = false;
    if (draftDate && minDt && isSameDay(draftDate, minDt) && h < minDt.getHours()) {
      disabled = true;
    }
    if (draftDate && maxDt && isSameDay(draftDate, maxDt) && h > maxDt.getHours()) {
      disabled = true;
    }
    return { value, label: value, disabled };
  });
}

export function buildMinuteOptions(
  draftDate: Date | null,
  selectedHour: number,
  min?: string,
  max?: string,
): SelectOption[] {
  const minDt = parseDateTimeLocal(min);
  const maxDt = parseDateTimeLocal(max);
  return MINUTE_VALUES.map((value) => {
    const m = Number(value);
    let disabled = false;
    if (
      draftDate &&
      minDt &&
      isSameDay(draftDate, minDt) &&
      selectedHour === minDt.getHours() &&
      m < minDt.getMinutes()
    ) {
      disabled = true;
    }
    if (
      draftDate &&
      maxDt &&
      isSameDay(draftDate, maxDt) &&
      selectedHour === maxDt.getHours() &&
      m > maxDt.getMinutes()
    ) {
      disabled = true;
    }
    return { value, label: value, disabled };
  });
}

export function firstEnabledValue(options: SelectOption[], fallback: string): string {
  return options.find((o) => !o.disabled)?.value ?? fallback;
}

export function isOptionDisabled(options: SelectOption[], value: string): boolean {
  return options.find((o) => o.value === value)?.disabled ?? false;
}

export function clampMinute(value: number): number {
  if (value < 0) return 59;
  if (value > 59) return 0;
  return value;
}

export function clampHour(value: number): number {
  if (value < 0) return 23;
  if (value > 23) return 0;
  return value;
}
